import React, { forwardRef, memo, useMemo } from 'react';
// import { areEqual } from 'app/libs/lifeCycle';
import useEnlog from 'app/hook/common/useEnlog';

import classNames from 'classnames/bind';
import styles from './InputOblong.module.scss';

const cx = classNames.bind(styles);

const InputOblong = forwardRef((props, ref) => {
	const {
		classArray = [],
		type,
		label,
		name,
		value = '',
		target,
		index = 0,
		onChange = () => console.warn('onChange is not defined.'),
		readOnly = false,
		disabled = false,
		labelSize = '14',
	} = props;

	const uniqueId = useMemo(() => `${name}${index}_${Math.random().toString(36).substr(2, 9)}$`, [index, name]);

	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);
	return (
		<span
			className={cx('uiinput_oblong', classArray)}
			data-testid="wrapOblong"
		>
			{type === 'radio' && (
				<>
					<input
						type={type}
						id={uniqueId}
						name={name}
						value={value}
						checked={value === target}
						onChange={onChange}
						ref={ref}
						disabled={readOnly || disabled}
						{...dataSet}
					/>
					<label
						htmlFor={uniqueId}
						data-testid="labelOblong"
						className={cx(`label_size${labelSize}`, { readonly: readOnly, disabled })}
					>
						<span className={cx('td')}>{label}</span>
					</label>
				</>
			)}

			{type === 'checkbox' && (
				<>
					<input
						type={type}
						id={uniqueId}
						name={name}
						value={value}
						checked={target}
						onChange={onChange}
						ref={ref}
						disabled={readOnly || disabled}
						{...dataSet}
					/>
					<label
						htmlFor={uniqueId}
						data-testid="labelOblong"
						className={cx(`label_size${labelSize}`, { readonly: readOnly, disabled })}
					>
						<span className={cx('td')}>{label}</span>
					</label>
				</>
			)}
		</span>
	);
});

export default memo(InputOblong);
